// Angular
import { Injectable, OnDestroy, OnInit } from '@angular/core';

// Libraries
import { Action, Selector, State, StateContext } from '@ngxs/store';

// Models
import { AppCleanup } from '../../../shared/models';
import { OutputConfigViewModel } from '../models/output-config-view.model';

// Store
import { OutputConfigActions } from './output-config.action';

export interface OutputConfigStateModel {
	items: OutputConfigViewModel[];
	loaded: boolean;
}

const defaultState: OutputConfigStateModel = {
	items: undefined,
	loaded: false,
};

@State<any>({
	name: 'outputConfig',
	defaults: defaultState,
})
@Injectable()
export class OutputConfigState extends AppCleanup implements OnInit, OnDestroy {
	constructor() {
		super();
	}

	ngOnInit() {}

	ngOnDestroy() {
		super.ngOnDestroy();
	}
	@Action(OutputConfigActions.SetAll)
	setAll(ctx: StateContext<OutputConfigStateModel>, action: OutputConfigActions.SetAll) {
		ctx.setState({
			items: action.configs,
			loaded: true,
		});
	}

	@Selector()
	static isLoaded(state: OutputConfigStateModel): boolean {
		return state.loaded;
	}

	@Selector()
	static channels(state: OutputConfigStateModel): OutputConfigViewModel[] {
		return state.items;
	}
}
